// src/components/analytics/AnalyticsKPICards.js
import React from 'react';
import { UsersIcon, TagIcon, GiftIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const AnalyticsKPICards = ({ dateRange, selectedProgram }) => {
    // Mock data - In a real application, this would come from an API based on filters
    const kpis = {
        totalMembers: '1,250',
        totalPointsIssued: '2,500,000',
        totalPointsRedeemed: '1,800,000',
        redemptionRate: '72%',
        averageMemberSpend: '$125.30',
        newMembers: '+85',
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-6">
            <div className="bg-white rounded-lg shadow-md p-6 flex items-center space-x-4">
                <div className="p-3 bg-indigo-100 rounded-full">
                    <UsersIcon className="h-6 w-6 text-indigo-600" />
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-500">Total Loyalty Members</p>
                    <p className="text-2xl font-bold text-gray-900">{kpis.totalMembers}</p>
                    <p className="text-xs text-gray-500">({kpis.newMembers} new {dateRange})</p>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 flex items-center space-x-4">
                <div className="p-3 bg-green-100 rounded-full">
                    <TagIcon className="h-6 w-6 text-green-600" />
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-500">Total Points Issued</p>
                    <p className="text-2xl font-bold text-gray-900">{kpis.totalPointsIssued}</p>
                    <p className="text-xs text-gray-500">(in {dateRange})</p>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 flex items-center space-x-4">
                <div className="p-3 bg-red-100 rounded-full">
                    <GiftIcon className="h-6 w-6 text-red-600" />
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-500">Total Points Redeemed</p>
                    <p className="text-2xl font-bold text-gray-900">{kpis.totalPointsRedeemed}</p>
                    <p className="text-xs text-gray-500">(in {dateRange})</p>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 flex items-center space-x-4">
                <div className="p-3 bg-yellow-100 rounded-full">
                    <ChartBarIcon className="h-6 w-6 text-yellow-600" />
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-500">Redemption Rate</p>
                    <p className="text-2xl font-bold text-gray-900">{kpis.redemptionRate}</p>
                    <p className="text-xs text-gray-500">(for {dateRange})</p>
                </div>
            </div>
            {/* Add more KPI cards as needed */}
        </div>
    );
};

export default AnalyticsKPICards;